<template>
  <div>
    <div class="navbar">

        <nav class="navbar navbar-expand-lg navbar-light">
        <a class="navbar-brand" href="#">
            <img class="navbar-brand" id="navbar-logo" src="@/assets/logo.png">
        </a>

        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav ml-auto">
            <li class="nav-item" :class="{active:selected == 'introduction'}">
                <router-link :to="'/' + dataset + '/introduction'" class="nav-link" @click.native="selected = 'introduction'">Dataset Description</router-link>
            </li>
            <li class="nav-item" :class="{active:selected == 'sample-data'}">
                <router-link :to="'/' + dataset + '/sample-data'" class="nav-link" @click.native="selected = 'sample-data'">Sample data</router-link>
            </li>
            </ul>
        </div>
        </nav>

    </div>
  </div>
</template>

<script>
export default {
  name: 'Navigation',
  data () {
    return {
      data: 'Welcome to Your Vue.js App',
      dataset: this.$route.params.dataset,
      selected: this.$route.name
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.navbar{
  background-color: #F4EFEA;
}
#navbar-logo{
  width: 300px;
}
</style>



// WEBPACK FOOTER //
// src/components/Navigation.vue